import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import { PreReleaseFeature } from 'hooks/usePreReleaseFeatures';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { layers } from 'app/spacing';
import { AUTHORIZED_EMBED_IFRAME_PATH } from 'services/AxiosService';

const TestingModeWrapper = styled.div`
  position: fixed;
  bottom: ${({ zendeskLoaded }) => (zendeskLoaded ? '70' : '10')}px;
  right: calc(10px + var(--app-inset-right, 0px));
  /* to be below ScrollTopButton (1039) and modal backdrop (1040)  */
  z-index: ${layers.toast};
  padding: 5px 0;
  background: var(--color-background-white);
  border: 1px solid var(--color-border-medium);
  border-radius: 4px;

  body:has([data-qa-id='pi-chat']) & {
    display: none;
  }

  && p {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 91px;
    height: 19px;
    font-size: 12px;
    line-height: 14px;
    color: var(--color-viz-cat-2-primary);
  }
`;

export const TestingMode = () => {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname.startsWith(AUTHORIZED_EMBED_IFRAME_PATH)) {
    return null;
  }

  return (
    <PreReleaseFeature>
      <TestingModeWrapper data-qa="testing-mode">
        <KizenTypography>{t('Testing Mode')}</KizenTypography>
      </TestingModeWrapper>
    </PreReleaseFeature>
  );
};
